'use client';

import React, { ReactNode, useState } from 'react';

import { Eye, Funny, Karma2, ThumbsUp, Verificated, Wallet } from '@ui/uikit/components/icons/mono';

import { SubmitYourAppModal } from './SubmitYourAppModal';

type SubmitYourAppButtonsProps = {
  id: number;
  icon: ReactNode;
  label: string;
};

const cards: SubmitYourAppButtonsProps[] = [
  {
    id: 1,
    icon: <Karma2 height={48} width={48} className="text-base-text-pink" />,
    label: 'FREE listing and access to a\u00A0vibrant, active community',
  },
  {
    id: 2,
    icon: <Eye height={48} width={48} className="text-base-text-tertiary" />,
    label: 'Increased visibility\u00A0&\u00A0credibility',
  },
  {
    id: 3,
    icon: <Funny height={48} width={48} className="text-base-text-orange" />,
    label: 'Valuable user feedback\u00A0&\u00A0insights',
  },
  {
    id: 4,
    icon: <Verificated height={48} width={48} className="text-base-text-pink" />,
    label: 'Streamlined project validation\u00A0process',
  },
  {
    id: 5,
    icon: <Wallet height={48} width={48} className="text-base-text-blue" />,
    label: 'Exposure to potential investors\u00A0& partnerships',
  },
  {
    id: 6,
    icon: <ThumbsUp height={48} width={48} className="text-base-text-green" />,
    label: 'Hassle-free listing \u00A0and\u00A0integration process',
  },
];

export const SubmitYourAppPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleClick = () => setIsModalOpen(true);

  const handleLoad = () => setIsVideoLoaded(true);

  return (
    <main className="v2-container flex flex-col items-center xl-msq:mb-10">
      <section className="flex flex-col items-center pt-12 xl-msq:pt-32 gap-24 min-w-[328px] max-w-[488px] xl-msq:max-w-[656px] xl-msq:gap-32 3xl-msq:max-w-[1376px]">
        <header className="flex flex-col gap-4">
          <h1 className="text-h1-m mt-12 text-center xl-msq:mt-0 xl-msq:text-h1-a">
            List Your Project, Skyrocket Success
          </h1>
          <div className="flex flex-col items-center gap-8 xl-msq:gap-10">
            <div className="text-base-text-tertiary text-center text-caption-md-m xl-msq:text-caption-md-a">
              <p>
                List your project for FREE on Magic Store, the premier Web3 App Store.
                <br />
                Reach new audiences and unlock your project's potential
              </p>
            </div>
            <button
              className="msq-btn msq-btn-primary msq-btn-lg w-full md-msq:w-[216px]"
              onClick={handleClick}
              aria-expanded={isModalOpen}
              aria-controls="submit-modal"
            >
              Get Started
            </button>
          </div>
        </header>

        <div className="flex flex-col gap-6 xl-msq:gap-8">
          <h2 className="text-h2-m text-center xl-msq:text-h2-a">
            The Magic Solution:
            <br className="3xl-msq:hidden" />
            Key Benefits of Listing Your Project
          </h2>
          <div
            className="
            grid grid-cols-2 auto-rows-[164px] justify-center gap-2
            md-msq:auto-rows-[148px]
            xl-msq:auto-rows-[172px] xl-msq:grid-cols-3 xl-msq:gap-4
            3xl-msq:grid-cols-6
            "
          >
            {cards.map(({ id, icon, label }) => (
              <div
                key={id}
                className="flex flex-col items-center justify-start gap-5 py-6 px-3 border border-base-border-medium rounded-lg sm-msq:px-6 xl-msq:px-2 xl-msq:py-8"
              >
                <span className="w-12 h-12">{icon}</span>
                <span className="text-caption-sm-strong-m text-center xl-msq:text-caption-sm-strong-a">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col items-center 3xl-msq:flex-row xl-msq:gap-12">
          <div className="w-full aspect-video">
            {!isVideoLoaded && <div className="skeleton-block" />}
            <video
              src="https://s3.eu-central-1.wasabisys.com/magicsquare.io/S_SteveAndSteve.mp4"
              autoPlay
              loop
              playsInline
              muted
              controls
              className="rounded-lg 3xl-msq:max-w-[664px] "
              onLoadedData={handleLoad}
            />
          </div>
          <div className="flex flex-col gap-4 mt-10 xl-msq:mt-0 xl-msq:gap-6 3xl-msq:mt-0 3xl-msq:self-start">
            <h2 className="text-h2-m text-left xl-msq:text-h2-a">
              Why List Your Project on Magic Store?
            </h2>
            <p className="text-caption-md-a">
              Magic Store is the go-to platform for users to discover and engage with exceptional
              Web3 projects. By listing your project with us for FREE, you'll gain increased
              visibility, credibility, and a growing user base. Upgrade to premium advertising
              features at your convenience.
            </p>
            <p className="text-h4-m xl-msq:text-h4-a">
              Don't miss out on the benefits of being part of the Magic Store ecosystem. Join today
              for FREE and watch your project soar!
            </p>
            <button
              className="msq-btn msq-btn-primary msq-btn-lg w-full self-center md-msq:w-[216px] mt-4 xl-msq:self-start"
              onClick={handleClick}
              aria-expanded={isModalOpen}
              aria-controls="submit-modal"
            >
              List Your Project Now
            </button>
          </div>
        </div>
      </section>
      <SubmitYourAppModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </main>
  );
};
